export default __webpack_public_path__ + "static/media/http-header.540dacf7.png";